module.exports = __webpack_public_path__ + "img/dalston_b_b1.d1285d34.jpg";